import { Resource } from "../resource";

export class PasswordChange extends Resource {
  paramName: string | null | undefined;
  paramNewValue: string | null | undefined;
  name: string | null | undefined;
}
